import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { pageSizeFromSearch } from '@/lib/list-pagination'

/** 10 when page_size is absent. A present value outside 10/20/50 is snapped and the URL is replaced. */
export function useListPageSize(): number {
  const [sp, setSp] = useSearchParams()
  const raw = sp.get('page_size')
  const { size, rewrite } = pageSizeFromSearch(raw)
  useEffect(() => {
    if (!rewrite) return
    const next = new URLSearchParams(sp)
    next.set('page_size', rewrite)
    setSp(next, { replace: true })
  }, [rewrite, sp, setSp])
  return size
}
